/*
Sohel 03/21/2023 2699762545 Added letter Group Screen
*/
import React from 'react';
import {Draggable} from 'react-beautiful-dnd';
import {withField} from './LetterFormatFieldsComponents/withField';
function LetterGroupRecordTable(props) {
  const {value, index} =
    props;
  // const [isDelete, setIsDelete] = useState(false);
  // const handleClose = () => {
  //   setIsDelete(false);
  // };
  // const handleConfirmDelete = () => {
  //   dmArrayHelpers.current.remove(index);
  //   const data = [...values.groupRecords]?.filter(
  //     (i) => i.recordCode !== values?.groupRecords[index]?.recordCode
  //   );
  //   setFieldValue("groupRecords", data);
  //   setIsDelete(false);
  // };
  return (
    <>
      <Draggable key={index} draggableId={'draggable-' + index} index={index}>
        {(provided) => (
          <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
            <td className="recFormat-col global-field-textfields">{index + 1}</td>

            <td className="recFormat-col global-field-textfields">{value.letterCode}</td>
            <td className="recFormat-col global-field-textfields">{value.letterDescription}</td>
          </tr>
        )}
      </Draggable>
    </>
  );
}
export default withField(LetterGroupRecordTable);
